import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-warning-casse-offline-dialog',
  templateUrl: './warning-casse-offline-dialog.component.html',
  styleUrls: ['./warning-casse-offline-dialog.component.css']
})
export class WarningCasseOfflineDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: { casse: any }) {


  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/warning-casse-offline-dialog/warning-casse-offline-dialog.component.ts